export default __webpack_public_path__ + "static/valencia-c93fe9c1052b1a65007ce47050d90e0b.jpg";